/* import __COLOCATED_TEMPLATE__ from './link-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();